import { render, staticRenderFns } from "./index.vue?vue&type=template&id=824b9e1a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=824b9e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824b9e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('824b9e1a')) {
      api.createRecord('824b9e1a', component.options)
    } else {
      api.reload('824b9e1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=824b9e1a&scoped=true&", function () {
      api.rerender('824b9e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Breadcrumb/index.vue"
export default component.exports